import { memo, useEffect, useState } from 'react';

import TwoOptionDialog from '~/core/middle-office/components/TwoOptionDialog.component';
import { isProductionEnv } from '../utils/environment';

const ServiceWorkerWatcherComponent = () => {
  const [isUpdateAvailable, setIsUpdateAvailable] = useState(false);

  useEffect(() => {
    if ('serviceWorker' in navigator && isProductionEnv()) {
      let intervalId: NodeJS.Timeout;
      window.addEventListener('load', () => {
        navigator.serviceWorker
          .register('/service-worker.js')
          .then((registration) => {
            console.log('SW registered: ', registration);
            if (intervalId) clearInterval(intervalId);
            intervalId = setInterval(
              () => {
                registration.update();
                console.log('Service worker updated.');
              },
              5 * 60 * 1000,
            );

            registration.addEventListener('updatefound', () => {
              console.log('SW update found!');
              if (document.referrer !== '') {
                setIsUpdateAvailable(true);
              } else {
                window.location.reload();
              }

              registration?.waiting?.postMessage({
                type: 'SKIP_WAITING',
              });
            });
          })
          .catch((registrationError) => {
            console.log('SW registration failed: ', registrationError);
          });
      });
    }
  }, []);

  return (
    <TwoOptionDialog
      acceptButtonText="Update"
      bodyText="Update will reload the page. Changes will not be saved."
      cancelButtonText="Close"
      headerText="New version available"
      isOpen={isUpdateAvailable}
      onAccept={() => window.location.reload()}
      onClose={() => setIsUpdateAvailable(false)}
    />
  );
};

export const ServiceWorkerWatcher = memo(ServiceWorkerWatcherComponent);
